import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BaseUserResponse } from '@models/user';
import { UserSystemCodes } from '@models/support/office-user-group';
import { GenericGeoUnit } from '@shared/models/generic-geo-unit';
import { GeoUnitType } from '@models/partners/partner-const-types';
import type { MappedCountryData, CountriesHashData } from '@core/services/geo-unit.service';
import { AllowedCountry } from '@models/allowedCountry';

@Injectable({
  providedIn: 'root',
})
export class AppContextService {
  currentUser = new BehaviorSubject<BaseUserResponse>(null);
  availableCountries = new BehaviorSubject<GenericGeoUnit<GeoUnitType.COUNTRY>[]>(null);
  mappedCountries = new BehaviorSubject<MappedCountryData[]>(null);
  countriesHashMap: CountriesHashData;

  get currentUserValue(): BaseUserResponse | null {
    return this.currentUser.value;
  }

  get currentUserOfficeId(): number | undefined {
    return this.currentUserValue?.user?.companyId;
  }

  get isHeadOfficeStaff(): boolean {
    return this.currentUserOfficeId === -3;
  }

  get currentUserGroupSystemCode(): UserSystemCodes | undefined {
    return this.currentUserValue?.userGroup?.systemCode;
  }

  get allowedCountries(): AllowedCountry[] {
    const stored = localStorage.getItem('allowedCountry');
    return stored ? (JSON.parse(stored) as AllowedCountry[]) : [];
  }

  get currentCountry(): AllowedCountry | null {
    const countries = this.allowedCountries;
    return countries?.[0] ?? null;
  }

  get currencySymbol(): string | null {
    return this.currentCountry?.currencySymbol ?? null;
  }

  get currencyCode(): string | null {
    return this.currentCountry?.currencyCode ?? null;
  }

  get currencyId(): number | null {
    return this.currentCountry?.currencyId ?? null;
  }
}
